import List from "@/components/list";
import router from "@/router";

const Table = (args) => {
  const { listeners, props } = args;
  const toInfo = listeners["toInfo"] || function() {};

  const Deal = ({ props: { vo } }) => {
    const item = vo.row
    const dealConf = [
      [
        "iconfont icjiexixiangqing iconfont-adapt",
        "查看详情",
        () => { toInfo(item) },
        "",
      ],
    ];
    return (
      <div class="deal-group">
        {dealConf.map((item) => (
          <el-tooltip content={item[1]} placement="top" v-permission={item[3]}>
            <i class={item[0]} onClick={item[2]}></i>
          </el-tooltip>
        ))}
      </div>
    );
  };

  const VideoName = ({ props: { vo } }) => {
    const item = vo.row;
    return (
      <span
        class="blue_text ellipsis--l1"
        onClick={() => {
          router.push({
            path: "/video/detail",
            query: { id: item.videoId },
          });
        }}
      >
        {item.videoName}
      </span>
    );
  };

  const AccountTableConfig = [
    {
      label: "视频名称",
      prop: "videoName",
      minWidth: "300",
      showOverflowTooltip: true,
      render: vo => <VideoName vo={vo} />
    },
    {
      label: "讲师",
      prop: "lecturerName",
      minWidth: "80",
    },
    {
      label: "时长",
      prop: "videoLengthFormat",
      minWidth: "100",
    },
    {
      label: "上线状态",
      prop: "onlineStatusStr",
      minWidth: "80",
    },
    
    {
      label: "解析时间",
      prop: "modifyDate",
      minWidth: "150",
      showOverflowTooltip: true,
    },
    {
      label: "操作",
      minWidth: "60",
      fixed: "right",
      render: (vo) => <Deal vo={vo} />,
    },
  ];

  if (props.isTopLevel) {
    AccountTableConfig.splice(3, 0, {
      label: "版权方",
      prop: "deptName",
      minWidth: "100",
    })
  }

  return (
    <div>
      <List
        {...args}
        talbeCols={AccountTableConfig}
      />
    </div>
  );
};

export default Table;
